import api from "./api";

export const getConsolidatedMetrics = () => {
  return api.get(`admin/metrics`);
};

export const getMetricsByPeriod = (type, period) => {
  return api.get(`admin/metrics/period/${type}/${period}`);
};

export const getMailMetrics = () => {
  return api.get(`admin/metrics/restricted_emails`);
};
export const getDomainsMetrics = () => {
  return api.get(`admin/metrics/emails`);
};

